import type { ReactNode } from "react"

interface StatBox {
  label: string
  /** Optional second line label */
  subLabel?: string
  value: string | number | ReactNode
  /** Whether this is a highlighted/active stat */
  highlighted?: boolean
}

interface HpiStatsBarProps {
  /** Title shown above the stats (e.g. "NEEDS ATTENTION") */
  title?: string
  stats: StatBox[]
  className?: string
}

export function HpiStatsBar({
  title,
  stats,
  className = "",
}: HpiStatsBarProps) {
  return (
    <div className={className}>
      {title && (
        <h2 className="text-hpi-dark-gray mb-3 text-xl font-semibold tracking-wide">
          {title}
        </h2>
      )}
      <div className="flex gap-4">
        {stats.map((stat, i) => (
          <div
            key={i}
            className="border-hpi-light-gray min-w-[140px] border-t-2 bg-white px-4 py-3"
          >
            <div className="text-hpi-active-blue text-xs font-medium">
              {stat.label}
            </div>
            {stat.subLabel && (
              <div className="text-hpi-active-blue text-xs font-medium">
                {stat.subLabel}
              </div>
            )}
            <div className="text-hpi-dark-blue mt-1 text-3xl font-light">
              {stat.value}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
